// extracted by mini-css-extract-plugin
module.exports = {"section":"CardList_section__1lxYY"};